<template>
  <div>Content Page</div>
</template>

<script>
</script>
